import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

import { MultiScale } from './multi-scale';
import { MultiScaleOption } from './multi-scale-option';

@Component({
  selector: 'nec-multi-scale-select',
  templateUrl: './multi-scale-select.component.html',
  styleUrls: ['./multi-scale-select.component.scss']
})
export class NecMultiScaleSelectComponent implements OnInit, OnChanges {
  @Input() multiScale: MultiScale = new MultiScale();
  @Output() selectChange: EventEmitter<number> = new EventEmitter();
  isShowOptions: boolean;

  constructor(private elementRef: ElementRef) {
    document.addEventListener('click', this.offClickHandler.bind(this));
  }

  ngOnInit() {
    this.isShowOptions = false;
  }

  ngOnChanges(changes: SimpleChanges) {
    this.multiScale = changes.multiScale.currentValue;
  }

  optionsShowChange() {
    this.isShowOptions = !this.isShowOptions;
  }

  optionChange(option: MultiScaleOption, scaleIndex: number) {
    this.multiScale.setNextScale(option, scaleIndex).changeOption(option, scaleIndex);
    this.selectChange.emit(option.id);
  }

  /**
   * å¤çé¼ æ ç¹å»ç»ä»¶å¤åç´ äºä»¶
   * @param event äºä»¶
   */
  offClickHandler(event: any) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      if (this.isShowOptions) {
        this.isShowOptions = false;
      }
    }
  }

}
